<template>
  <v-container class="fill-height ma-0 pa-0" fluid>
    <v-layout row class="back-color-light" :style="cssVars">
      <v-col xs="12" md="5" class=" ma-0 pa-0">
        <v-row class="back-color px-8" justify="center">
          <v-img alt="Logo do Orçamento Participativo" class="shrink" contain
            src="../assets/logo-orcamento-participativo-branco.svg" max-width="368" />
        </v-row>
        <v-container class="login-container">
          <v-row align="center" justify="center" class="login-row">
            <v-col class="login-exact-col">
              <v-tabs v-model="tab" show-arrows background-color="green" icons-and-text dark grow>
                <v-tabs-slider color="purple darken-4"></v-tabs-slider>
                <v-tab v-for="i in tabs" :key="i.id">
                  <v-icon large>{{ i.icon }}</v-icon>
                  <div class="caption py-1">{{ i.name }}</div>
                </v-tab>
                <v-tab-item>
                  <v-card class="px-4">
                    <v-card-text>
                      <v-form ref="loginFormSSHD" class="login-form" @submit.prevent="handleLoginSshd">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field filled label="SSHD" prepend-inner-icon="mdi-account"
                              :background-color="darkMode ? '#4445' : '#FFF7'"
                              :color="darkMode ? 'success' : 'primary'"
                              class="mb-0.5" autofocus
                              v-model="sshdUser.sshd"
                              :rules="[rules.required, rules.min]"
                              validate-on-blur
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field filled label="Senha" :type="passBool ? 'password' : 'text'"
                              prepend-inner-icon="mdi-lock" :background-color="darkMode ? '#4445' : '#FFF7'"
                              :color="darkMode ? 'success' : 'primary'" class="mb-1"
                              :append-icon="passBool ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="() => (passBool = !passBool)" v-model="sshdUser.password"
                              :rules="[rules.required]" validate-on-blur></v-text-field>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6" xsm="12">
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-btn type="submit" color="success" x-large block :loading="loading" :disabled="loading"
                            class="mb-6">Entrar
                          </v-btn>
                          <modal :modalStatus="showModal" @closeFromModal="hideModal" v-if="showModal" />
                        </v-row>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- <v-tab-item>
                  <v-card class="px-4">
                    <v-card-text>
                      <v-form @submit.prevent="handleLoginCnpj" ref="loginFormCNPJ" class="login-form">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field filled label="CNPJ" v-maska="'##.###.###/####-##'"
                              prepend-inner-icon="mdi-account" :background-color="darkMode ? '#4445' : '#FFF7'"
                              :color="darkMode ? 'success' : 'primary'" class="mb-0.5" autofocus v-model="cnpjUser.cnpj"
                              :rules="[rules.required, rules.min]" validate-on-blur>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field filled label="Senha" :type="passBool ? 'password' : 'text'"
                              prepend-inner-icon="mdi-lock" :background-color="darkMode ? '#4445' : '#FFF7'"
                              :color="darkMode ? 'success' : 'primary'" class="mb-1"
                              :append-icon="passBool ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="() => (passBool = !passBool)" v-model="cnpjUser.password"
                              :rules="[rules.required]" validate-on-blur></v-text-field>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6" xsm="12">
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-btn type="submit" color="success" x-large block :loading="loading" :disabled="loading"
                            class="mb-6">Entrar
                          </v-btn>
                          <modal :modalStatus="showModal" @closeFromModal="hideModal" v-if="showModal" />
                        </v-row>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-tab-item> -->
              </v-tabs>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col md="7" class="image-container hidden-sm-and-down" fluid align="right">
        <div class="back"></div>
        <v-img alt="Logo da Prefeitura de Santos" class="logo prefeitura mr-14 mt-10" contain
          src="../assets/brasao-branco-horizontal.svg" width="190" />
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import { maska } from 'maska'
import SSHDUser from '../models/SSHDUser';
// import CNPJUser from '../models/CNPJUser';
import Modal from '../components/Modal';
import getErrorMessage from '../utils/getErrorMessage';
import getLocalStorageDarkMode from '../utils/getLocalStorageDarkMode';

export default {
  directives: { maska },
  name: 'Login',
  props: {
    source: String,
  },
  components: {
    Modal
  },
  data() {
    return {
      darkMode: false,
      sshdUser: new SSHDUser(),
      // cnpjUser: new CNPJUser(),
      showModal: false,
      loading: false,
      message: '',
      status: 0,
      countSubmits: 0,
      passBool: String,
      rules: {
        required: value => !!value || 'Campo obrigatório.',
        min: value =>
          value.length == 8 || 'Deve conter 8 caracteres',
      },
      cssVars: {
        '--text-color': '#c8e6c9',
      },
      tab: 0,
      tabs: [
        { name: "SSHD", icon: "mdi-account" },
        // { name: "CNPJ", icon: "mdi-office-building" },
      ],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.status.loggedIn;
    },
    recebeRealToken() {
      return this.$store.state.realTokenDecoded;
    },
  },
  created() {
    this.darkMode = getLocalStorageDarkMode();
    this.$vuetify.theme.dark = this.darkMode;
    if (this.loggedIn) {
      this.$router.push('/projects');
    }
  },
  methods: {
    async handleLoginSshd() {
      try {
        this.loading = true;

        if (!this.$refs.loginFormSSHD.validate()) {
          throw new Error('Verifique os campos em vermelho');
        }

        await this.$store.dispatch('login', this.sshdUser);

        if (!this.$store.state.token) {
          throw new Error(
            'O servidor não enviou a resposta esperada, ' +
            'avise o administrador do sistema',
          );
        }

        this.countSubmits = 0;
        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: 'Login efetuado com sucesso',
        });
      } catch (error) {
        const message = getErrorMessage(error);

        if (message === 'Usuário/senha inválidos') {
          this.countSubmits++;
          if (this.countSubmits > 3) {
            this.showModal = true;
          }
        }

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.loading = false;
        await this.$store.dispatch('decodeTokenAction', this.$store.state.token);
        this.$router.push('/projects');
      }
    },
    hideModal() {
      this.showModal = false;
    },
  },
  watch: {
    'sshdUser.sshd': {
      handler(newValue) {
        this.sshdUser.sshd = newValue.toUpperCase();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.back {
  position: absolute;
  background-image: url(../assets/bg-orcamentoparticipativo.jpg);
  background-size: cover;
  background-position-x: center;
  height: 100vh;
  width: 100%;
}

.back::after {
  position: absolute;
  content: '';
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(20deg,
      rgba(4, 44, 30, 0.6) 20%,
      rgba(0, 0, 0, 0) 30%,
      rgba(0, 0, 0, 0) 65%,
      rgba(53, 6, 124, 0.7) 100%);
}

.back-color {
  background-color: #053613;
  height: 32%;
  min-height: 175px;
}

.back-color-light {
  background-color: #053613;
}

.login-container {
  height: 68%;
}

.login-row {
  height: 100%;
  margin: 0 16px;
}

.login-exact-col {
  max-width: 350px;
  padding-bottom: 0;
}

.login-logo-text {
  color: var(--text-color);
  font-size: 28px;
}

.login-text {
  color: var(--text-color);
  max-width: 280px;
  line-height: 1.2;
  text-align: center;
}

.login-form {
  width: 100%;
}

.login-text-field {
  background-color: #418f89;
}

.image-container {
  position: relative;
  padding: 0;
}

.logo-prefeitura {
  position: absolute;
  top: 0;
  right: 0;
}

.copyright {
  display: flex;
  align-items: center;
  color: #e6f3e6;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
